import KYCVerification from '../../Auth/KYCVerification';
import { useUser } from '../../../contexts/UserContext';

/**
 * Identity Verification — thin wrapper around the KYC flow so it's a self-contained section
 * like the others. Extracted verbatim from AccountSettings (no behavior change).
 */
export function IdentitySection() {
  const { refreshUser } = useUser();

  // No toast on completion — KYCVerification renders an in-place success screen once verified.
  const handleKycComplete = (_status: 'verified' | 'pending' | 'rejected') => {
    refreshUser();
  };

  return (
    <div>
      <KYCVerification onVerificationComplete={handleKycComplete} />
    </div>
  );
}

export default IdentitySection;
